import React from 'react';
import { Helmet } from 'react-helmet';

// Import all favicon assets
import favicon from '../../assets/favicons/favicon.ico';
import favicon16 from '../../assets/favicons/favicon-16x16.png';
import favicon32 from '../../assets/favicons/favicon-32x32.png';
import appleTouchIcon from '../../assets/favicons/apple-touch-icon.png';
import androidChrome192 from '../../assets/favicons/android-chrome-192x192.png';
import androidChrome512 from '../../assets/favicons/android-chrome-512x512.png';

const Favicon: React.FC = () => {
  return (
    <Helmet>
      {/* Standard favicons */}
      <link rel="icon" href={favicon} />
      <link rel="icon" type="image/png" sizes="32x32" href={favicon32} />
      <link rel="icon" type="image/png" sizes="16x16" href={favicon16} />
      
      {/* Apple Touch Icon */}
      <link rel="apple-touch-icon" sizes="180x180" href={appleTouchIcon} />
      
      {/* Android Chrome icons */}
      <link rel="icon" type="image/png" sizes="192x192" href={androidChrome192} />
      <link rel="icon" type="image/png" sizes="512x512" href={androidChrome512} />
      
      {/* Theme colors */}
      <meta name="theme-color" content="#0e1f2f" />
      <meta name="msapplication-TileColor" content="#0e1f2f" />
    </Helmet>
  );
};

export default Favicon;